import React from 'react';

function OgSectionHead({ eyebrow, title, sub = null }) {
  return (
    <div className="og-section">
      <div className="og-section-head">
        <span className="eyebrow">{eyebrow}</span>
        <h2>{title}</h2>
        {sub ? <span className="sub">{sub}</span> : null}
        <span className="rule" />
      </div>
    </div>
  );
}

export default OgSectionHead;
